import React from "react";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createDocument } from "../../firebase/firebaseCrud";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CustomInput,
  CustomTextArea,
} from "../../components/Form/CustomInputField";
import CustomButton from "../../components/Form/CustomButton";
import MultipleSelector from "../../components/Form/MultipleSelector";
import { DataContext } from "../../context/data-context";
import convertToSlug from "../../utils/slugconverter";
import { ref, uploadBytes } from "firebase/storage";
import { imageDb } from "../../firebase";
import { useCart } from "../../context/cart-context";
import BackdropLoader from "../../components/Loading/BackdropLoader";
import generateUniqueReferenceID from "../../hooks/uniqueRefID";

const CreateProduct = () => {
  let navigate = useNavigate();
  const [productImage, setProductImage] = React.useState("");
  const { isLoading, setIsLoading } = useCart();

  const { formData, setFormData } = React.useContext(DataContext);
  const [errorMsg, setErrorMsg] = React.useState("");

  // const [contentPic, setContentPic] = React.useState("");

  // const handleContentPicChange = (event) => {
  //   const selectedFile = event.target.files[0];
  //   setErrorMsg("");

  //   if (selectedFile) {
  //     setFormData({ ...formData, imgSrc: selectedFile });
  //     setContentPic(selectedFile.name);
  //   }
  // };

  const category = ["Short", "Medium", "Long"];

  const handleNameSlug = () => {
    // console.log(name);
    let name = formData.name;
    const newSlug = convertToSlug(name);
    setFormData({ ...formData, slug: newSlug });
  };

  React.useEffect(() => {
    handleNameSlug();
  }, [formData.name]);

  const uploadImage = async () => {
    if (!productImage) return null;

    const formData = new FormData();
    formData.append("refId", "strandz123");
    formData.append("type", "ProductImage");
    formData.append("category", "strandz");
    formData.append("file", productImage, productImage.name);

    const res = await fetch(
      `${process.env.REACT_APP_RN_BASE_API}/file/upload`,
      {
        method: "POST",
        body: formData,
        // DO NOT set Content-Type manually for FormData
      }
    );

    if (!res.ok) {
      const errText = await res.text().catch(() => "");
      throw new Error(`Image upload failed (${res.status}). ${errText}`);
    }

    const data = await res.json(); // assuming API returns JSON
    // adjust this to match your API response shape
    const imgUrl = data?.imgUrl;

    if (!imgUrl) {
      throw new Error(
        "Upload succeeded but imgUrl was not returned by the API."
      );
    }

    return imgUrl;
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg("");

    try {
      // Validate text fields first (optional but nicer UX)
      if (formData.name === "")
        return setErrorMsg("Name of product cannot be empty");
      if (formData.price === 0)
        return setErrorMsg("Price of product cannot be empty");
      if (formData.color === "")
        return setErrorMsg("Please select a color for product");
      if (formData.categories === "")
        return setErrorMsg("Categories of product cannot be empty");
      if (formData.type === "")
        return setErrorMsg("Type of product cannot be empty");
      if (formData.description === "")
        return setErrorMsg("Description of product cannot be empty");
      if (!productImage)
        return setErrorMsg("Please select an image for the product.");

      // 1) Upload image and get URL
      const imgUrl = await uploadImage();

      if (!imgUrl) {
        return console.log("No image provided", imgUrl);
      } else {
        console.log("imgUrl", imgUrl);
      }

      // 2) Create product using returned URL
      const payload = {
        ...formData,
        imgSrc: imgUrl,
      };

      const newDoc = await createDocument("product-list", payload);

      toast(`Product Created with ID: ${newDoc}`, { type: "success" });

      setFormData({
        name: "",
        price: 0,
        limit: 0,
        imgSrc: "",
        slug: "",
        categories: "",
        type: "",
        color: "",
        description: "",
      });

      setTimeout(() => {
        navigate("/dashboard");
      }, 6000);
    } catch (error) {
      console.error(error);
      setErrorMsg(error?.message || "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  // const handleImage = async () => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const prodImgName = generateUniqueReferenceID(
  //         `ProdImg-${formData.name}`
  //       );
  //       setFormData((prevState) => ({ ...prevState, imgSrc: prodImgName }));

  //       const imgRef = ref(imageDb, `elegant-moi/${prodImgName}`);

  //       if (productImage) {
  //         await uploadBytes(imgRef, productImage);
  //         console.log("Image uploaded successfully!");
  //         resolve(prodImgName); // Resolve with the prodImgName
  //       } else {
  //         console.error("No image selected");
  //         setErrorMsg("Please select an image for the product.");
  //         reject(new Error("No image selected"));
  //       }
  //     } catch (error) {
  //       console.error("Error uploading image: ", error);
  //       setErrorMsg("Error uploading image.");
  //       reject(error);
  //     }
  //   });
  // };

  // const handleCreate = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   if (!productImage) {
  //     setErrorMsg("Please select an image for the product.");
  //     return;
  //   }

  //   try {
  //     // Upload the image and get the prodImgName
  //     const prodImgName = await handleImage();

  //     // Now proceed with form validation using prodImgName
  //     if (formData.name === "") {
  //       setErrorMsg("Name of product cannot be empty");
  //     } else if (!prodImgName) {
  //       setErrorMsg("Please select an image for product");
  //     } else if (formData.price === 0) {
  //       setErrorMsg("Price of product cannot be empty");
  //     }
  //     // else if (formData.limit === 0) {
  //     //   setErrorMsg("Quantity of product cannot be empty");
  //     // }
  //     else if (formData.color === "") {
  //       setErrorMsg("Please select a color for product");
  //     } else if (formData.categories === "") {
  //       setErrorMsg("Categories of product cannot be empty");
  //     } else if (formData.type === "") {
  //       setErrorMsg("Type of product cannot be empty");
  //     } else if (formData.description === "") {
  //       setErrorMsg("Description of product cannot be empty");
  //     } else {
  //       // Update formData with prodImgName before saving the product
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         imgSrc: prodImgName,
  //       }));

  //       // Save the product after the image has been uploaded
  //       try {
  //         const newDoc = await createDocument("product-list", {
  //           ...formData,
  //           imgSrc: prodImgName,
  //         });

  //         setFormData({
  //           name: "",
  //           price: 0,
  //           limit: 0,
  //           imgSrc: "",
  //           slug: "",
  //           categories: "",
  //           type: "",
  //           color: "",
  //           description: "",
  //         });

  //         toast(`Product Created with ID: ${newDoc}`, {
  //           type: "success",
  //         });

  //         setTimeout(() => {
  //           setIsLoading(false);

  //           navigate("/dashboard");
  //         }, 6000);
  //       } catch (error) {
  //         setIsLoading(false);
  //         console.error("Error creating document: ", error);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error in image upload:", error);
  //   }
  // };

  return (
    <React.Fragment>
      <BackdropLoader open={isLoading} />
      <ToastContainer />

      <Box sx={{ maxWidth: 720 }}>
        {errorMsg && (
          <Alert
            severity="error"
            onClose={() => setErrorMsg("")}
            sx={{ mb: 3, borderRadius: "8px" }}
          >
            {errorMsg}
          </Alert>
        )}

        {/* Basic info card */}
        <Box
          sx={{
            bgcolor: "#fff",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            p: 3,
            mb: 3,
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#111827", mb: 0.5 }}>
            Product Details
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#6b7280", mb: 3 }}>
            Basic information about the product.
          </Typography>

          <Grid container spacing={2}>
            <Grid xs={12} sm={8} item>
              <CustomInput
                label="Product Name"
                type="text"
                className="w-full"
                onChange={(e) => { setFormData({ ...formData, name: e.target.value }); setErrorMsg(""); }}
                value={formData.name}
              />
            </Grid>

            <Grid xs={12} sm={4} item>
              {/* Styled file input */}
              <Box
                sx={{
                  border: "1px dashed #d1d5db",
                  borderRadius: "8px",
                  p: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  bgcolor: "#f9fafb",
                  gap: 0.5,
                }}
                component="label"
              >
                <Typography sx={{ fontSize: 12, color: "#6b7280", textAlign: "center" }}>
                  {productImage ? productImage.name : "Click to upload image"}
                </Typography>
                <input
                  type="file"
                  hidden
                  onChange={(e) => setProductImage(e.target.files[0])}
                />
              </Box>
            </Grid>

            <Grid xs={12} item>
              <CustomTextArea
                label="Product Description"
                type="text"
                rowNo={3}
                className="w-full"
                onChange={(e) => { setFormData({ ...formData, description: e.target.value }); setErrorMsg(""); }}
                value={formData.description}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Pricing & inventory card */}
        <Box
          sx={{
            bgcolor: "#fff",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            p: 3,
            mb: 3,
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#111827", mb: 0.5 }}>
            Pricing &amp; Inventory
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#6b7280", mb: 3 }}>
            Set price, stock quantity, and available colours.
          </Typography>

          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item>
              <CustomInput
                label="Price (£)"
                type="number"
                className="w-full"
                onChange={(e) => { setFormData({ ...formData, price: e.target.value }); setErrorMsg(""); }}
                value={formData.price}
              />
            </Grid>
            <Grid xs={12} sm={4} item>
              <CustomInput
                label="Stock Quantity"
                type="number"
                className="w-full"
                onChange={(e) => { setFormData({ ...formData, limit: e.target.value }); setErrorMsg(""); }}
                value={formData.limit}
              />
            </Grid>
            <Grid xs={12} sm={4} item>
              <CustomInput
                label="Available Colours"
                type="text"
                className="w-full"
                onChange={(e) => { setFormData({ ...formData, color: e.target.value }); setErrorMsg(""); }}
                value={formData.color}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Category card */}
        <Box
          sx={{
            bgcolor: "#fff",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            p: 3,
            mb: 3,
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#111827", mb: 0.5 }}>
            Category
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#6b7280", mb: 3 }}>
            Select one or more categories for this product.
          </Typography>
          <MultipleSelector label="Product Categories" data={category} />
        </Box>

        {/* Submit */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <CustomButton
            type="submit"
            sx={{ height: "44px", px: 5 }}
            color="primary"
            className="text-sm !uppercase"
            onClick={handleCreate}
          >
            Create Product
          </CustomButton>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CreateProduct;
